import React from "react";
import { Box, Card, CardContent, Typography, Grid } from "@mui/material";
import { Title } from "react-admin";

const CakeWelcomePage = () => (
  <Box sx={{ padding: "20px" }}>
    <Title title="Welcome to Cake AI" />
    {/* Hero Section */}
    <Card
      sx={{
        marginBottom: "20px",
        textAlign: "center",
        padding: "40px",
        boxShadow: "none",
        borderRadius: "12px",
      }}
    >
      <img
        src="https://trycake.com/cdn/shop/files/Deskt_Head_2200x980_72480adc-486d-4249-91ca-2e2fe68d1707.jpg?v=1724420447&width=2200"
        alt="Cake AI for Restaurants"
        style={{ width: "80%", height: "auto", objectFit: "contain", marginBottom: "20px" }}
      />

      <Typography
        variant="h2"
        component="h1"
        gutterBottom
        sx={{ fontWeight: "bold", fontSize: "2.5rem", lineHeight: "1.2" }}
      >
        Revolutionize Your Restaurant with Cake AI
      </Typography>
      <Typography
        variant="h6"
        component="p"
        gutterBottom
        sx={{  marginBottom: "20px" }}
      >
        An AI-driven extension of the Cake POS system, Cake AI offers next-level
        analytics, smart assistants, and seamless access to your restaurant's
        essential knowledge base.
      </Typography>
    </Card>

    {/* Key Features Section */}
    <Grid container spacing={2} sx={{ display: "flex", alignItems: "stretch" }}>
      {/* First Row */}
      <Grid item xs={12} md={6} sx={{ display: "flex" }}>
        <Card
          sx={{
            flexGrow: 1,
            marginBottom: "20px",
            padding: "20px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
            minHeight: "400px",
            "&:hover": {
              boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
              transform: "translateY(-5px)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            },
          }}
        >
          <CardContent>
            <img
              src="https://madmobile.com/wp-content/uploads/2022/08/cake_mm_restaurant-reporting-by-cake.webp"
              alt="Advanced Analytics"
              style={{
                width: "100%",
                height: "auto",
                display: "block",
                margin: "0 auto",
                marginTop: "20px",
              }}
            />

            <Typography
              variant="h4"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold",  textAlign: "center", marginTop: "20px" }}
            >
              Advanced Analytics & Reports
            </Typography>
            <Typography
              variant="body1"
              component="p"
              sx={{ textAlign: "center" }}
            >
              Unlock the power of your restaurant's data. Cake AI delivers
              real-time insights and analytics, helping you optimize your
              operations, track sales trends, and monitor customer preferences.
              See the bigger picture with easy-to-read reports and dashboards
              that bring clarity to your decision-making.
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} md={6} sx={{ display: "flex" }}>
        <Card
          sx={{
            flexGrow: 1,
            marginBottom: "20px",
            padding: "20px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
            minHeight: "400px",
            "&:hover": {
              boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
              transform: "translateY(-5px)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            },
          }}
        >
          <CardContent>
            <img
              src="https://trycake.com/cdn/shop/files/Products_AI-Reporting_2ce72dce-7a10-45f9-ad59-2e19f5a24ddb.png?v=1723727322&width=900"
              alt="AI Assistant"
              style={{
                width: "100%",
                height: "300px",
                display: "block",
                margin: "0 auto",
                marginTop: "20px",
                objectFit: "cover",
                objectPosition: "center", // Zoom in on the image
              }}
            />

            <Typography
              variant="h4"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold",  textAlign: "center", marginTop: "40px" }}
            >
              AI Assistant for Restaurants
            </Typography>
            <Typography
              variant="body1"
              component="p"
              sx={{  textAlign: "center" }}
            >
            Your personal restaurant management assistant is here. From
              automating routine tasks to offering real-time advice, Cake AI’s
              assistant is designed to make managing your restaurant simpler and
              more efficient. Ask questions, receive recommendations, and
              automate tasks.
              </Typography>
          </CardContent>
        </Card>
      </Grid>

      {/* Second Row */}
      <Grid item xs={12} md={6}>
        <Card
          sx={{
            marginBottom: "20px",
            padding: "20px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
            minHeight: "400px",
            "&:hover": {
              boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
              transform: "translateY(-5px)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            },
          }}
        >
          <CardContent>
            <img
              src="https://trycake.com/cdn/shop/articles/blog-cover-2-1.webp?v=1723589831&width=1200"
              alt="Knowledge Base"
              style={{
                width: "100%",
                height: "auto",
                display: "block",
                margin: "0 auto",
                marginTop: "20px",
              }}
            />

            <Typography
              variant="h4"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", textAlign: "center", marginTop: "20px" }}
            >
              Knowledge Base in AI Chat
            </Typography>
            <Typography
              variant="body1"
              component="p"
              sx={{ textAlign: "center" }}
            >
              Get instant access to the entire Cake POS Knowledge Base right
              within the Cake AI assistant. Whether you're troubleshooting a
              system issue or checking your support cases, Cake AI integrates
              all support documentation and service updates.
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} md={6}>
        <Card
          sx={{
            marginBottom: "20px",
            padding: "20px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
            minHeight: "400px",
            "&:hover": {
              boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
              transform: "translateY(-5px)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            },
          }}
        >
          <CardContent>
            <img
              src="https://res.cloudinary.com/dcppnhptx/image/upload/v1729139045/Build_Hero_Illustration_d5ee5v.png"
              alt="Integrations"
              style={{
                width: "100%",
                height: "auto",
                display: "block",
                margin: "0 auto",
                marginTop: "20px",
              }}
            />
            <Typography
              variant="h4"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold",  textAlign: "center", marginTop: "20px" }}
            >
              Easy Integrations
            </Typography>
            <Typography
              variant="body1"
              component="p"
              sx={{ textAlign: "center" }}
            >
              Early Access to the Cake Integration Marketplace for quick, easy
              integrations to your other tools and solutions.
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  </Box>
);

export default CakeWelcomePage;